import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';

import {generateImage, type GenerateImageParams, type GenerateImageResponse} from '@/api/images'

import { queryKeys } from '@/lib/queryKeys';

export function useGenerateImageMutation(
    options?: UseMutationOptions<GenerateImageResponse, Error, GenerateImageParams>,
    ) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: generateImage,
        onSuccess: () => {
        queryClient.invalidateQueries({
            queryKey: queryKeys.images.history(),
        });
        },
        ...options,
    });
}